import { HttpClient } from '@packages/shared/core/common/services';
import { ApiPathAskGateway, ApiPathMain } from '@packages/shared/core/common/constants/apiPaths';
import { User } from '../../entities';

type UserUpdateInfo = Partial<{
  birth_day: string;
  birth_place: string;
  gender: string;
  name: string;
  phone_number: string;
}>;

export class UserService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly askGatewayHttpClient: HttpClient,
  ) {}

  async updateUserInformation(data: UserUpdateInfo): Promise<void> {
    await this.askGatewayHttpClient.put(ApiPathAskGateway.USER_PROFILE_UPDATE, {
      data,
    });
  }

  async getUser(): Promise<User> {
    const { data } = await this.httpClient.get<User>(ApiPathMain.USER_PROFILE);
    return data;
  }

  async changeEmail(email: string): Promise<void> {
    await this.askGatewayHttpClient.put(ApiPathAskGateway.ACCOUNT_EMAIL, {
      data: { email },
    });
  }

  async setEmailConsent(emailConsent: boolean): Promise<void> {
    await this.askGatewayHttpClient.post(ApiPathAskGateway.NOTIFICATION_CONSENT_EMAIL, {
      data: { consent_value: emailConsent },
    });
  }
}
